import { Extension } from "@tiptap/core";
import { TextStyleKit } from "@tiptap/extension-text-style";
import StarterKit from "@tiptap/starter-kit";

import { fontSizeClassForDeclaration } from "@av/components/atoms/html-transport";
import { configuredLinkExtension } from "./link-config";

// CSP blocks inline style="font-size:Npx"; renders class="av-sanitized-font-size-N" instead.
type FontSizeOptions = { types: string[] };

export const FontSize = Extension.create<FontSizeOptions>({
  name: "fontSize",

  addOptions() {
    return { types: ["textStyle"] };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => {
              if (element.style.fontSize) return element.style.fontSize;

              // CSP can preserve the attribute while blocking CSSOM access to it.
              // A regex reads the single font-size declaration here; this
              // intentionally differs from convertSpanStyleToClasses' split(";")
              // parser in html-transport.ts, which walks every declaration.
              const declaration = element
                .getAttribute("style")
                ?.match(/(?:^|;)\s*font-size\s*:\s*([^;]+)/i);

              return declaration?.[1].trim() || null;
            },
            renderHTML: (attributes) => {
              if (!attributes.fontSize) return {};
              const className = fontSizeClassForDeclaration(attributes.fontSize as string);

              if (!className) return {};

              return { class: className };
            },
          },
        },
      },
    ];
  },
});

export const richTextEditorExtensions = [
  TextStyleKit.configure({ fontSize: false }),
  FontSize,
  StarterKit.configure({ link: false, horizontalRule: false }),
  configuredLinkExtension({ autolink: true }),
];
